/* Brinde: sachê de teste de sensibilidade em todo pedido (substitui o que a Yever fazia).
   Sachê Hidratante Corporal Alto Desempenho (PRHCAD10G), cadastrado a R$ 0,01 no Shopify
   (sem desconto, para nenhum cupom anular o brinde). Este script garante que o item entre
   no carrinho por qualquer caminho até o checkout: carrinho, "Comprar agora", botão de
   finalizar e quiz (window.PeleRaraBrinde.garante). Sempre 1 unidade, e nunca sozinho. Kit de avaliação profissional fica de
   fora: já é outro programa de brinde. */
(function () {
  var BRINDE_VARIANT_ID = 43494524125319;
  var EXCLUI_VARIANT_IDS = [45945664077959];
  var BRINDE_ITEM = { id: BRINDE_VARIANT_ID, quantity: 1, properties: { Brinde: 'Teste de sensibilidade' } };
  var emCurso = null;

  function temVariante(itens, ids) {
    return itens.some(function (it) { return ids.indexOf(it.variant_id) !== -1; });
  }

  function precisa(cart) {
    return !!(cart && cart.items && cart.items.length) &&
      !temVariante(cart.items, [BRINDE_VARIANT_ID]) && !temVariante(cart.items, EXCLUI_VARIANT_IDS);
  }

  function carrinho() {
    return fetch(window.routes.cart_url + '.js').then(function (r) { return r.json(); });
  }

  function adiciona(itens) {
    return fetch(window.routes.cart_add_url, Object.assign(fetchConfig('json'), { body: JSON.stringify({ items: itens }) }))
      .then(function (r) { return r.json(); });
  }

  function avisaTema() {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'brinde-sensibilidade' });
    }
  }

  function muda(chave, quantidade) {
    return fetch(window.routes.cart_change_url, Object.assign(fetchConfig('json'), { body: JSON.stringify({ id: chave, quantity: quantidade }) }))
      .then(function (r) { return r.json(); });
  }

  // Um sachê por pedido, e só junto de outro produto: corrige quantidade e tira o sachê sozinho.
  function corrige(c) {
    var saches = (c.items || []).filter(function (it) { return it.variant_id === BRINDE_VARIANT_ID; });
    if (!saches.length) return null;
    var outros = c.items.length - saches.length;
    var passos = saches.map(function (it, i) {
      var alvo = outros && i === 0 ? 1 : 0;
      return it.quantity === alvo ? null : function () { return muda(it.key, alvo); };
    }).filter(Boolean);
    if (!passos.length) return null;
    return passos.reduce(function (p, f) { return p.then(f); }, Promise.resolve());
  }

  // Confere o carrinho e põe o sachê se faltar. Resolve sempre, mesmo com erro: nunca trava a compra.
  function garante(cart) {
    if (emCurso) return emCurso;
    emCurso = (cart ? Promise.resolve(cart) : carrinho())
      .then(function (c) {
        var ajuste = corrige(c);
        if (ajuste) return ajuste.then(function () { avisaTema(); return true; });
        if (!precisa(c)) return false;
        return adiciona([BRINDE_ITEM]).then(function () { avisaTema(); return true; });
      })
      .catch(function () { return false; })
      .finally(function () { emCurso = null; });
    return emCurso;
  }

  function vaiAoCheckout() {
    if (typeof window.endShopping === 'function') window.endShopping();
    else window.location.href = '/checkout';
  }

  // "Comprar agora": adiciona o produto do formulário junto com o sachê e abre o checkout.
  function comprarAgora(evento, botao) {
    var pf = botao.closest('product-form');
    var form = botao.closest('form') || (pf && pf.querySelector('form'));
    if (!form || !form.querySelector('[name="id"]')) return;
    evento.preventDefault();
    evento.stopImmediatePropagation();
    var dados = new FormData(form);
    var item = { id: Number(dados.get('id')), quantity: Number(dados.get('quantity') || 1), properties: {} };
    dados.forEach(function (v, k) {
      var m = k.match(/^properties\[(.+)\]$/);
      if (m) item.properties[m[1]] = v;
    });
    carrinho()
      .then(function (c) {
        var itens = [item];
        if (EXCLUI_VARIANT_IDS.indexOf(item.id) === -1 && !temVariante(c.items || [], [BRINDE_VARIANT_ID].concat(EXCLUI_VARIANT_IDS))) {
          itens.push(BRINDE_ITEM);
        }
        return adiciona(itens);
      })
      .catch(function () {})
      .finally(vaiAoCheckout);
  }

  document.addEventListener('click', function (evento) {
    var alvo = evento.target;
    if (!alvo || !alvo.closest) return;
    var compra = alvo.closest('.shopify-payment-button__button, shopify-buy-it-now-button');
    if (compra) return comprarAgora(evento, compra);

    // Finalizar compra antes de o sachê entrar: segura o clique, garante e segue.
    var finalizar = alvo.closest('[name="checkout"], a[href="/checkout"]');
    if (!finalizar || finalizar.dataset.brindeOk) return;
    evento.preventDefault();
    evento.stopImmediatePropagation();
    garante().then(function () {
      finalizar.dataset.brindeOk = '1';
      vaiAoCheckout();
    });
  }, true);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (evento) {
      if (evento && evento.source === 'brinde-sensibilidade') return;
      garante(evento && evento.cartData && evento.cartData.items ? evento.cartData : null);
    });
  }

  window.PeleRaraBrinde = { garante: garante };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { garante(); });
  else garante();
})();
